module.exports = __webpack_public_path__ + "static/media/FederalElection2025LogoMobile.7f6b685f.svg";